import React, { Component } from 'react';

import Message from './Message';


class Io extends Component {
  constructor(props, context) {
    super(props);
    this.state = {
      open: false,
      message: null,
    }
    this.queue = [];

    this.handleIncomingMessages = this.handleIncomingMessages.bind(this);
    this.processQueue = this.processQueue.bind(this);
    this.handleClose = this.handleClose.bind(this);
  }

  shouldComponentUpdate(nextProps) {
    if (nextProps.io.messages.length > this.props.io.messages.length) {
      this.handleIncomingMessages(
        [...nextProps.io.messages],
        [...this.props.io.messages]
      );
      return false;
    }
    return true;
  }

  handleIncomingMessages(nextMessages, prevMessages) {
    this.queue.push(
      ...(nextMessages.slice(
        prevMessages.length
      ))
    );

    if (this.state.open)  this.setState({ open: false });
    else                  this.processQueue();
  }

  processQueue = () => {
    if (this.queue.length > 0) {
      this.setState({
        message: this.queue.shift(),
        open: true,
      });
    }
  };

  handleClose = (event, reason) => {
    if (reason === 'clickaway') return;
    this.setState({ open: false });
  };

  handleExited = () => {
    this.processQueue();
  };


  render() {
    let {message} = this.state;

    return (
      <Message
        message={message}
        open={this.state.open}
        onClose={this.handleClose}
        onExited={this.handleExited}
      />
    );
  }
}

export default Io;



// WEBPACK FOOTER //
// ./src/components/modules/io/Io.js